import CommonStyles from 'shared/style/commonPageStyles'
import styled from 'styled-components'

const Style = {
	Wrapper: CommonStyles.PageWrapper,
	InputWrapper: styled.div`
		height: 40px;
		display: flex;
		gap: 8px;

		& > input {
			width: 100%;
			${({theme}) => theme.font.extra_small};
			padding: 0 20px;
			border: 1px solid ${({theme}) => theme.color.grey3};
			border-radius: 4px;
		}
	`,
}

export default Style
